import { Box, Divider, Typography } from "@mui/material";
import { useAppSelector } from "../../store/hooks";
import { RootState } from "../../store/store";
import CommunicationTemplatesStyles from "./CommunicationTemplatesStyles";
import TemplateVersionsCard from "./TemplateVersionsCard";
import ViewTemplate from "./ViewTemplate";
import { Dispatch, FC, SetStateAction, useState } from "react";
import { ICreatedTemplateData } from "../../models/admin/communicationTemplates/communicatinTemplates";
import CustomSkeleton from "../../common/CustomSkeleton/CustomSkeleton";
interface ITemplateVersionsHistoryProps {
  setRevertTemplateTo: Dispatch<SetStateAction<ICreatedTemplateData | null>>;
}
const TemplateVersionsHistory: FC<ITemplateVersionsHistoryProps> = ({
  setRevertTemplateTo,
}) => {
  const { templateVersions } = useAppSelector(
    (store: RootState) => store.communicationTemplates
  );
  const { isLoading, calledReducerType } = useAppSelector(
    (state: RootState) => state.common
  );

  const [selectedVersion, setSelectedVersion] =
    useState<ICreatedTemplateData | null>(null);

  const handleVersionCardClick = (template: ICreatedTemplateData) => {
    if (template) {
      setSelectedVersion(template);
      setRevertTemplateTo(template);
    }
  };
  return (
    <Box sx={{ display: "flex", gap: "0.75rem" }}>
      <Box sx={CommunicationTemplatesStyles.versionsDataContainer}>
        <Box>
          <Typography
            sx={CommunicationTemplatesStyles.versionDataSectionHeading}
          >
            Versions
          </Typography>
        </Box>
        <Divider />
        <Box sx={CommunicationTemplatesStyles.versionsData}>
          {isLoading &&
          calledReducerType === "getCommunicationTemplate/versions" ? (
            <CustomSkeleton height={100} direction="column" />
          ) : (
            templateVersions?.map((version) => (
              <TemplateVersionsCard
                versionsData={version}
                key={version?.id}
                handleVersionCardClick={handleVersionCardClick}
              />
            ))
          )}
        </Box>
      </Box>
      <Box sx={CommunicationTemplatesStyles.versionDetailsContainer}>
        <Typography sx={CommunicationTemplatesStyles.versionDataSectionHeading}>
          Version Details
        </Typography>
        <Divider />
        <Box sx={{ padding: "1rem" }}>
          {selectedVersion && <ViewTemplate template={selectedVersion} />}
        </Box>
      </Box>
    </Box>
  );
};

export default TemplateVersionsHistory;
